import styled, { css } from 'styled-components';

const StyledFlexRoomCard = css`
  align-items: center;
  align-content: center;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  gap: 2rem;
  height: auto;
  justify-content: space-between;
  width: 100%;
`;

export const StyledRoomTag = styled.p`
  background-color: #224633;
  color: #f9f9fb;
  padding: 0 1rem;
  border-radius: 1.5rem;
  font-size: ${({ theme }) => theme.fonts.sizes.small};
  line-height: 1.8rem;
`;

export const StyledRoomCard = styled.a`
  ${StyledFlexRoomCard}
  max-width: 38rem;
  min-height: 4.8rem;
  display: flex;
  flex-direction: row;
  background-color: #212c42;
  border: 1px solid #212c42;
  padding: 1.2rem;
  flex-flow: nowrap;
  border-radius: 0.5rem;
  gap: 0.5rem 0rem;
  text-decoration: none;

  &:hover {
    background-color: #3e475a;
    border: 1px solid #878fa2;
  }
  > div {
    align-items: center;
    display: flex;
    gap: 1rem;
  }
  > div:nth-child(2) {
    margin-left: 2.5rem;
  }
  cursor: pointer;

  p {
    line-height: 2rem;
  }

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) and (max-width: ${({ theme }) => theme.sizes.lg}) {
    flex-flow: wrap;
  }
`;
export const StyledRoomImage = styled.img`
  width: 2rem;
  height: 2rem;
  object-fit: cover;
`;
